import { Card, View } from "@/components/ui";
import { SuggestionServiceList } from "./suggestion-service-list";
import { ListHeading } from "@/components/shared/list-header";
import type { Icon } from "@/components/shared/icons";
import { recommendedServiceItems } from "../homepage/lib";

export function SuggestionServiceSection({
  title,
  icon,
}: {
  title: string;
  icon: Icon;
}) {
  return (
    <Card shadow="sm">
      <View className="shadow- flex flex-col gap-2 p-4">
        <ListHeading title={title} icon={icon} />
        <SuggestionServiceList items={recommendedServiceItems} />
      </View>
    </Card>
  );
}
